export function getLatestInactiveCard(inactiveCards) {
  const sortedInActiveCards = inactiveCards?.sort(
    (cardA, cardB) =>
      new Date(cardB?.validityEndDate).getTime() -
      new Date(cardA?.validityEndDate).getTime()
  )

  return sortedInActiveCards?.length ? sortedInActiveCards[0] : null
}
